import FnrEnvironment from "Utilities/FnrEnvironment";
import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";

import FnrFetch4 from "../Utilities/FnrFetch/FnrFetch4";

import devAPI from "./API.dev.js";
import { mockData } from "./mockData";

let API = {
  getGroupBoard: ({ groupURL, boardURL, bypassSavedBoardFilter = true }) => {
    let fetchFunction = mockData.shouldMock
      ? callMockResponse(mockData.getGroupBoard)
      : new FnrFetch3(
          "/board/getGroupBoard",
          {
            groupURL,
            sheetURL: boardURL,
            bypassSavedBoardFilter,
          },
          false
        );
    return fetchFunction;
  },

  getSignupBoard: ({ signupListID }) =>
    new FnrFetch3("/board/getSignupBoard", { signupListID }, false),

  getReportBoard: ({ boardID, bypassSavedBoardFilter = false }) =>
    new FnrFetch3(
      "/board/getReportBoard",
      { boardID, bypassSavedBoardFilter },
      false
    ),

  createBoard: ({ groupURL, title }) =>
    new FnrFetch3(
      "/board/createBoard",
      {
        groupURL,
        title,
      },
      false
    ),

  deleteBoard: ({ boardID, groupURL }) =>
    new FnrFetch3(`/board/${boardID}/deleteBoard`, { groupURL }, false),

  renameBoard: ({ boardID, title, groupURL }) =>
    new FnrFetch3(`/board/${boardID}/renameBoard`, { title, groupURL }, false),

  saveData: ({
    groupID,
    signupListID,
    boardID,
    columnID,
    entityID,
    entityType,
    value,
    filters,
  }) =>
    new FnrFetch3(
      `/board/${boardID}/saveData`,
      {
        groupID,
        signupListID,
        columnID,
        entityID,
        entityType,
        value,
        request: filters,
      },
      false
    ),

  renameColumn: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/renameColumn`, postData, false),

  addColumn: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/addColumn`, postData, false),

  deleteColumn: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/deleteColumn`, postData, false),

  reorderColumn: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/reorderColumn`, postData, false),

  getFilters: ({ boardID, groupID }) =>
    new FnrFetch3(`/board/${boardID}/getFilters`, { groupID }, false),

  checkAll: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/checkAllInColumn`, postData, false),

  uncheckAll: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/uncheckAllInColumn`, postData, false),

  getExportFilterRequestID: ({ groupURL, filters, savedFilterRequestID }) =>
    new FnrFetch3(
      `/board/createSavedFilterRequest`,
      { groupURL, request: filters, savedFilterRequestID },
      false
    ),

  checkForFeature: () => new FnrFetch3(`/board/hasFeature`, false),

  getAvailableGroupsForLinking: (postData) =>
    new FnrFetch3(`/board/getAvailableGroupsForLinking`, postData, false),

  duplicateBoard: (postData) =>
    new FnrFetch3(`/board/duplicateBoard`, postData, false),

  createNewBoardWithAllColumnsLinked: (boardID, postData) =>
    new FnrFetch3(
      `/board/${boardID}/createNewBoardWithAllColumnsLinked`,
      postData
    ),

  linkBoardToAnotherGroup: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/linkBoardToAnotherGroup`, postData),

  saveFiltersAsReport: ({ groupID, title, filters }) =>
    new FnrFetch3(`/board/saveFiltersAsReport`, { groupID, title, filters }),

  getAvailableColumnsToLinkToBoard: (boardID) =>
    new FnrFetch3(
      `/board/${boardID}/getAvailableColumnsToLinkToBoard`,
      {},
      false
    ),

  linkColumnToBoard: (boardID, postData) =>
    new FnrFetch3(`/board/${boardID}/linkColumnToBoard`, postData),

  getBoardExtendedFields: (boardID) => {
    let fetchFunction = mockData.shouldMock
      ? callMockResponse(mockData.getBoardExtendedFields)
      : new FnrFetch4(
          `/board/${boardID}/getAvailableExtendedFieldColumns`,
          null
        );
    return fetchFunction;
  },

  triggerExport: ({ filterRequestID, boardID, groupURL, savedFilterRequestID }) => { 
    const url = filterRequestID
      ? `/board/${boardID}/export?filterRequestID=${filterRequestID}&groupURL=${groupURL}&savedFilterRequestID=${savedFilterRequestID}`
      : `/board/${boardID}/export?groupURL=${groupURL}`;
    
    let fetchFunction = mockData.shouldMock
      ? callMockResponse(mockData.triggerExport)
      : new FnrFetch3(url);
    return fetchFunction;
  }
};

if (FnrEnvironment.shouldUseDevAPI()) API = { ...API, ...devAPI };

export default API;